import {
    getInvoice,
    listInvoices
} from './queries';
import {
    createInvoice,
    deleteInvoice,
    sendInvoice,
    updateInvoice,
    voidInvoice,
} from './mutations';

import {GraphQLQuery,} from '@aws-amplify/api';
import {
    CreateInvoice,
    DeleteInvoice,
    GetInvoice,
    Invoice,
    ListInvoices,
    SendInvoice,
    UpdateInvoice,
    VoidInvoice
} from "../types.ts";
import {generateClient} from "aws-amplify/api";


const client = generateClient();

export const fetchRecords = async (filter: object, limit?: number, nextToken?: string) => {
    const response = await client.graphql<GraphQLQuery<ListInvoices>>({
                                                                          query: listInvoices,
                                                                          variables: {filter: filter, limit, nextToken},
                                                                      });
    return response.data?.listInvoices;
};

export const fetch = async (id: string) => {
    const response = await client.graphql<GraphQLQuery<GetInvoice>>({
                                                                        query: getInvoice,
                                                                        variables: {id: id},
                                                                    });
    return response.data?.getInvoice;
};

export const add = async (payload: object) => {
    const response = await client.graphql<GraphQLQuery<CreateInvoice>>({
                                                                           query: createInvoice,
                                                                           variables: {input: payload},
                                                                       });
    return response.data?.createInvoice;
};

// FNP-918 (§6): the payload arrives already WHITELISTED by `toInvoiceInput` in
// hooks/useInvoice.ts. This function used to spread the record and `delete`
// `created`/`updated` off the copy — a denylist, which silently forwards every
// field the UI later adds (`createdAtMillis`, for one). Whitelisting at the
// hook is the single place that decision belongs; re-deleting here would only
// hide a caller that skipped it.
export const update = async (_id: string, record: Invoice) => {
    const payload = record as unknown as Record<string, unknown>;

    const response = await client.graphql<GraphQLQuery<UpdateInvoice>>({
                                                                           query: (updateInvoice),
                                                                           variables: {input: payload},
                                                                       });
    return response.data?.updateInvoice;
};

export const deleteRecord = async (id: string) => {
    const response = await client.graphql<GraphQLQuery<DeleteInvoice>>({
                                                                           query: (deleteInvoice),
                                                                           variables: {input: {id: id}},
                                                                       });
    return response.data?.deleteInvoice;
};

export const send = async (id: string) => {
    const response = await client.graphql<GraphQLQuery<SendInvoice>>({
                                                                         query: (sendInvoice),
                                                                         variables: {input: {id: id}},
                                                                     });
    return response.data?.sendInvoice;
};

export const voidRecord = async (id: string) => {
    const response = await client.graphql<GraphQLQuery<VoidInvoice>>({
                                                                         query: (voidInvoice),
                                                                         variables: {input: {id: id}},
                                                                     });
    return response.data?.voidInvoice;
};
